import { z } from 'zod';

export const schemaConsorsBlz = z
    .string()
    .min(8)
    .max(8)
    .regex(/^[0-9]+$/, 'Invalid characters');
